import { flat, map, pipe, repeat, toArray } from '@fxts/core';
import { html, type Html, Page } from 'rune-ts';
import UAParser from 'ua-parser-js';
import { mpsPostMessage } from '../../../shared/app/util';
import { ButtonAction } from '../../../shared/components/atoms/ButtonAction/ButtonAction';
import { font } from '../../../shared/typography';
import { getSharedData } from '../../../shared/util/rune';
import { MarppleShopLogo, MarppleShopTextLogoLarge } from '../../components/atoms/Icon';
import klass from './MarppleshopAppLink.module.scss';

export type MarppleshopAppLinkPageData = {
  url: string;
};

export class MarppleshopAppLinkPage extends Page<MarppleshopAppLinkPageData> {
  static creator_images = [
    [
      '//s3.marpple.co/files/u_2283830/2025/1/original/262d91c156f4f870ab27a454759df3e73be14bc534.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/4e4890ebfdb5f207fbc6cdca99abb4d429b1540033.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/a6e63ca993e84c621a5dc7a42225118e94de64c232.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/43fd339e67d9d71846d8b1d9bdde22d790976d5a31.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/028eec4909da4fed0f17543b2ab6864cea578ce730.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/30e1c514cf9ba1aa9ea72fcce5100a6033d8213929.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/c20ef582e4a2b1f0619294bbe1610c41477f75ab28.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/d89800b209e414572fcbd3e71058b3701db76d4027.png',
    ],
    [
      '//s3.marpple.co/files/u_2283830/2025/1/original/9af7b75413392fe116cfa342c22e54c642000fb026.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/a28039b07a055d07f0c5aaecb4e783c1ddd3d10725.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/2ea97c357dec8be399b9fa812dd0b66a8646ec4024.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/4a1bd82091d773dbebb1fa27b190bd70efe3f4de23.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/9f9e57449f1721636976e7fc4f2e010be494a26b22.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/dd63d8c8e52733faf3d45c6e30f8c838f6ce5db921.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/a7967d8d19caa724356cf54236344d40a65343cc20.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/689ec9d6d7bac04d3a996be268c648461a621edc19.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/79a954f62ad34be9c5eb1c9aec34e129e963443e18.png',
    ],
    [
      '//s3.marpple.co/files/u_2283830/2025/1/original/93f34f284e43f97b3216cf6c9c034779efd6a64117.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/c5f52d00f3a9aee511b5c039b9e5df9b20e8780016.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/64a216ad52f69499e877f3072e289d610efc16ed15.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/333e44b33250adbab020a89bc0bb447185537d8b14.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/86826c1a0b12e5e25b32233ddc172938e01e46ec13.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/50923b1b2580ac966d6c3133e84c56011b6ddcb412.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/6d825ee3e91af295e21da0a0cb93af88bc2330fc11.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/70cf3c9005f027735e335a7f77d9eeaa3c8fc08110.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/496fe326d6496ef08b8127fd8da2e85b47cce2e09.png',
    ],
    [
      '//s3.marpple.co/files/u_2283830/2025/1/original/f46058b7b12681887389d2e6fcdc45ebe561e10f8.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/d251bfd1fbef13a9ff4e848c2d82167ec55de3cf7.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/b41f0ce439dc947c78bf2b3e9d02715a5477fe7c6.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/3e798508b0fb1196d5e728b6e85cd079512aea445.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/cc93cb397f43dd784ce1618a73de16a7c02a39934.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/2223047f743d082c0c957cee1a09dd6713be84e03.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/dc749a22ea108302096d3b8c21485b7f2609394e2.png',
      '//s3.marpple.co/files/u_2283830/2025/1/original/c5d1326a37d18db15588654330a8c1614713e7831.png',
    ],
  ];

  makeImages(index: number) {
    return pipe(
      MarppleshopAppLinkPage.creator_images[index],
      repeat(3),
      flat,
      map((image) => {
        return html`<img src="${image}" alt="creator" />`;
      }),
      toArray,
    );
  }

  protected override template(): Html {
    return html`
      <div class="${klass.wrapper}">
        <div class="${klass.page}">
          <section class="${klass.image_section} ${klass.top}">
            <div class="${klass.images}">${this.makeImages(0)}</div>
            <div class="${klass.images}">${this.makeImages(1)}</div>
          </section>
          <section class="${klass.notice}">
            <div class="${klass.body}">
              <div class="${klass.logo}">
                <span>${MarppleShopLogo}</span>
              </div>
              <div class="${klass.text_logo}">${MarppleShopTextLogoLarge}</div>
              <div class="${font('16_medium')}">
                ${html.preventEscape(ET('mps2::share::marppleshop_description'))}
              </div>
            </div>
            ${new ButtonAction({
              type: 'blue',
              size: 'large',
              label: ET('mps2::share::marppleshop_app_download'),
              klass: klass.button,
            })}
          </section>
          <section class="${klass.image_section} ${klass.bottom}">
            <div class="${klass.images}">${this.makeImages(2)}</div>
            <div class="${klass.images}">${this.makeImages(3)}</div>
          </section>
        </div>
      </div>
    `;
  }

  openAppStore() {
    const parser = new UAParser();
    const IS_IOS = /IOS/i.test(parser.getOS().name ?? '');

    const APP_STORE_URL = 'https://apps.apple.com/in/app/id1571108536';
    const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.marppleshop';

    window.location.href = IS_IOS ? APP_STORE_URL : PLAY_STORE_URL;
  }

  openApp() {
    const path = `marppleshop${this.data.url.startsWith('/') ? this.data.url : '/' + this.data.url}`;

    const APP_LINK = {
      production: `marppleshop://${path}`,
      staging: `marppleshopstaging://${path}`,
      development: `marppleshopdev://${path}`,
    } as const;

    const ENV = (process.env.NODE_ENV as keyof typeof APP_LINK) || 'development';

    // 딥링크 호출
    window.location.href = APP_LINK[ENV];
  }

  override onRender() {
    const sharedData = getSharedData(this);

    if (sharedData?.webviewapp) {
      mpsPostMessage({ goBack: true });
      return;
    }

    if (!sharedData?.is_mobile) {
      window.location.href = this.data.url;
      return;
    }

    this.openApp();

    this.delegate('click', ButtonAction, () => {
      this.openAppStore();
    });
  }
}
